import { FIELD_OWNERSHIP_OWNER } from './IntegrationsDataSources.constants'

export function getIsFieldOwnerPortal(owner) {
  return owner === FIELD_OWNERSHIP_OWNER.portal
}
